import * as React from 'react';

export function formatCisloUctu(bankovniUcet?: {predcisli?: string, cisloUctu: string, kodBanky: string}) {
    if (!bankovniUcet) {
        return '';
    }
    const predcisli = bankovniUcet.predcisli ? (bankovniUcet.predcisli + '-') : '';
    return (predcisli + bankovniUcet.cisloUctu + '/' + bankovniUcet.kodBanky);
}
